import { identify, makeRequest, Service } from '../../../utils/http';

export async function getAllOrdersApi() {
  return makeRequest(Service.getAllOrders(99999, 0, await identify()));
}
